// extracted by mini-css-extract-plugin
module.exports = {"menu":"Admin_menu__36NZ8"};